import React from 'react';
import { PROCEDURE_FIELD_DEFS } from '../utils/procedureFieldDefs';
import './ProcedureFieldKey.css';

const KEY_ORDER = ['reimb', 'marginPct', 'cm', 'directLtv', 'halo', 'total', 'pmRatio'];

/**
 * Compact legend for procedure economics column abbreviations.
 */
function ProcedureFieldKey({ className = '' }) {
  return (
    <div className={`proc-field-key ${className}`.trim()}>
      <span className="proc-field-key-title">Field key</span>
      <dl className="proc-field-key-list">
        {KEY_ORDER.map((id) => {
          const def = PROCEDURE_FIELD_DEFS[id];
          return (
            <div key={id} className="proc-field-key-item">
              <dt title={def.tooltip}>{def.shortLabel}</dt>
              <dd>{def.fullLabel} — {def.tooltip}</dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}

export default ProcedureFieldKey;
